/* expander.tsx generated by @compiled/babel-plugin v2.0.0 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._39xV02N91d%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._23rrnHpA9h%7Btransition%3Amax-height%20.3s%7D");
import { ExitingPersistence, FadeIn } from '@atlaskit/motion';
import { Box, Stack } from '@atlaskit/primitives/compiled';
const styles = {
  expander: "_39xV02N91d",
  container: "_23rrnHpA9h"
};
type ExpanderProps = {
  isExpanded: boolean;
  testId?: string;
  children: React.ReactNode;
};
const Expander = ({
  children,
  isExpanded,
  testId
}: ExpanderProps): JSX.Element => {
  // Need to always render the ExpanderInternal otherwise the
  // reveal transition doesn't happen. We can't use CSS animation for
  // the the reveal because we don't know the height of the content.

  return <Box xcss={styles.expander} style={{
    maxHeight: isExpanded ? 150 : 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    flex: '1 1 100%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    minWidth: 0
  }} aria-hidden={!isExpanded} testId={testId && `${testId}-expander`}>
			<ExitingPersistence appear>
				{isExpanded && <FadeIn>
						{props => <Box xcss={styles.container} {...props}>
								<Stack space="space.100">{children}</Stack>
							</Box>}
					</FadeIn>}
			</ExitingPersistence>
		</Box>;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Expander;